/**
 * FormData for the server's image-upload endpoints (`files` part + crop
 * fields). An all-zero crop is the renderer's "no crop" identity (see
 * data-access-cnt AuthService.uploadProfilePhoto), so admin uploads the full
 * frame; cropping stays in cnt-landing's own editors.
 */
export function photoUploadForm(file: File): FormData {
  const form = new FormData();
  form.append('files', file, file.name);
  form.append('caption', '');
  form.append('cropLeft', '0');
  form.append('cropTop', '0');
  form.append('cropRight', '0');
  form.append('cropBottom', '0');
  form.append('zoom', '1');
  form.append('rotation', '0');
  return form;
}
